import { render, staticRenderFns } from "./srPlatformManager.vue?vue&type=template&id=4eae031a"
import script from "./srPlatformManager.vue?vue&type=script&lang=js"
export * from "./srPlatformManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports